import { useQuery, keepPreviousData } from "@tanstack/react-query";

import { VirtualSportQueryKeys } from "./virtualSportQueryKeys";
import {
  getVirtualBasketballStandings,
  getVirtualStandings,
} from "@/api/virtualSport";
import { SPORT_CATEGORY } from "@/utils/sports";

// League standings (Puan Durumu) for a VFL league.
export const useVirtualStandings = (leagueId: number) =>
  useQuery({
    queryKey: [
      VirtualSportQueryKeys.Standings,
      SPORT_CATEGORY.VirtualFootball,
      leagueId,
    ],
    queryFn: () => getVirtualStandings(leagueId),
    enabled: Boolean(leagueId),
    refetchInterval: 60_000,
    placeholderData: keepPreviousData,
  });

// League standings for the VBL league (W/L, points for/against). Separate hook:
// the row shape differs from football's (no draws, points not goals).
export const useVirtualBasketballStandings = (leagueId: number) =>
  useQuery({
    queryKey: [
      VirtualSportQueryKeys.Standings,
      SPORT_CATEGORY.VirtualBasketball,
      leagueId,
    ],
    queryFn: () => getVirtualBasketballStandings(leagueId),
    enabled: Boolean(leagueId),
    refetchInterval: 60_000,
    placeholderData: keepPreviousData,
  });
